import state from "./state"

let getters = {
    restaurant: state=> {
        return state.restaurant
    },
    util: state=>{
        return state.util
    },
    restaurantPayment: state=> {
        if(state.restaurant){
            return state.restaurant.card_brands
        }
    },
    menu: state=>{        
        return state.menu
    },
    menuService:state=>{        
        return state.menuService
    },
    typeSelected: state=> {
        return state.typeSelected
    },
    subtypes: state=>{
        return state.subtypes
    },
    filter: state=>{
        return state.filter
    },
    isCleanPage: state=> {
        return state.isCleanPage
    },
    products: state=> {
        return state.products
    },
    pizza: state=> {
        return state.pizza
    },
    sizes: state=> {
        return state.sizes
    },
    product: state=>{
        return state.product
    },
    multiProducts: state=>{
        return state.multiProducts
    },
    type: state=>{
        return state.type
    },
    productShow: state=>{
        return state.product
    },
    user: state=> {
        return state.user
    },
    myOrders: state=> {
        return state.myOrders
    },
    myOrder: state=>{
        return state.myOrder
    },
    phone_validation: state=> {
        return state.phone_validation
    },
    userAddressDefault: state=>{
        // if(state.user){
        //     return state.user.address_list.find(v=>v.address_default==true)
        // }else{
        //     return null
        // }
        return null
    },
    authError: state=> {
        return state.authError
    },
    cart: state=> {
        return state.cart
    },
    agendamento: state=> {
        return state.agendamento
    },
    loading: state=> {
        return state.loading
    },
    cartProduct: state=> {
        return (id)=>state.cartProducts.find(p=>p._id==id)
    },
    cartQuant:state=>{
        if(state.cart && state.cart.products.length > 0){
            return state.cart.products
                .reduce((acc,cur)=>acc+cur.quantity,0)
        }else{
            return 0
        }
    },
    productQuant: state=>{
        return (id)=>{
            if(state.cart){
                let quant = state.cart.products.reduce((acc,p)=>{
                    if(p._id==id){
                        return acc += p.quantity
                    }else{
                        return acc
                    }
                
                },0)
                return quant
            }else{
                return 0
            }
        }
    },
    cartProducts: state=>{
        return state.cartProducts
    },
    pendingOrder: state=>{
        return state.pendingOrder
    },
    pendingOrderId: state=>{
        return state.pendingOrderId
    },
    tags: state=>{
        return state.tags
    },
    cities: state=>{
        return state.cities
    },
    states: state=>{
        return state.states
    },
    loading: state=>{
        return state.loading
    },
    payments: state=>{
        return state.payments
    },
    productDialog: state=>{
        return state.productDialog
    },
    typeDialog: state=>{
        return state.typeDialog
    },
    typeDialogCategory:state=>{
        return state.typeDialogCategory
    },
    typeDialogCategoryUpdate:state=>{
        return state.typeDialogCategoryUpdate
    },
    currentServiceTypeId:state=>{        
        return state.currentServiceTypeId        
    },
    currentServiceTypeName:state=>{
        return state.currentServiceTypeName
    }
    
    

}

export default getters